import { ProductFilter } from "./product-filter";
import { AbaIdFilter } from "./aba-id-filter";
import { VariantFilter } from "./variant-filter";
import { PlatformWrapper } from "./platform-filter";
import { CohortDateFilter } from "./cohort-date-filter";
import { MaxDayDiffFilter } from "./max-day-diff";
import { SubmitButton } from "./submit-button";

import { FormInstance } from "antd/lib/form";
import { FilterFormInstanceType } from "@src/contexts/ab-testing/ab-context";
import { FilterFormFieldsEnum } from "@src/pages/ab-test-explore/enum";
import { Checkbox, Form, Input } from "antd";
import React from "react";
import { ExtraFilterMain } from "./extra-filter";
import { BaseVariantFilter } from "./base-variant-filter";
import { TimeRangeFilter } from "./time-range-filter";
import { AbaViewConfig } from "./aba-view-config";

export const ABFilterFormContent: React.FC<{ form: FormInstance<FilterFormInstanceType> }> = ({ form }) => {
  return (
    <>
      <div className="flex justify-between w-full">
        <div className="flex flex-wrap space-x-2 mb-2">
          <ProductFilter form={form} />
          <AbaIdFilter form={form} />
          <CohortDateFilter form={form} />
          <MaxDayDiffFilter form={form} />
          <BaseVariantFilter form={form} />
          <TimeRangeFilter form={form} />
        </div>
        <div className="hidden">
          <PlatformWrapper form={form} />
          <VariantFilter form={form} />
        </div>
        <div className="flex items-start">
          <div className="pt-8">
            <AbaViewConfig form={form} />
          </div>
          <ExtraFilterMain form={form} />
          <SubmitButton form={form} />
        </div>
      </div>
      <Form.Item name={FilterFormFieldsEnum.IS_FIRST_APPLIED} hidden valuePropName="checked">
        <Checkbox />
      </Form.Item>
      <Form.Item name={FilterFormFieldsEnum.TICKET_ID} hidden>
        <Input />
      </Form.Item>
      <Form.Item name={FilterFormFieldsEnum.PMP_PRODUCT_ID} hidden>
        <Input />
      </Form.Item>
    </>
  );
};
